import { Button, Grid } from "@mui/material";
import JsonEditor from "../Common/JsonEditor";

type PayloadEditorProps = {
  payloadText: string;
  isPayloadEdited: boolean;
  selectedParserConfig: number;
  onPayloadChange: (value: string) => void;
  onParse: () => void;
  onError?: (error: Error) => void;
};

const PayloadEditor: React.FC<PayloadEditorProps> = ({
  payloadText,
  isPayloadEdited,
  selectedParserConfig,
  onPayloadChange,
  onParse,
  onError,
}) => {
  const handleParseClick = () => {
    try {
      const formatted = JSON.stringify(JSON.parse(payloadText), null, 2);
      onPayloadChange(formatted);
      onParse();
    } catch {
      onError?.(new Error("Geçersiz JSON"));
    }
  };

  return (
    <Grid
      container
      direction={"column"}
      size={{ xs: 12, md: 6 }}
      sx={{ paddingBottom: 2, paddingRight: { xs: 0, md: 2 }, minWidth: 0 }}
    >
      <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
        <JsonEditor value={payloadText} onChange={onPayloadChange} />
      </Grid>

      <Grid
        size={{ xs: 12 }}
        sx={{ display: "flex", justifyContent: "flex-start", pt: 1, gap: 2 }}
      >
        <Button
          size="medium"
          variant="outlined"
          sx={{
            px: 4,
            borderColor: "var(--color-primary)",
            color: "var(--color-primary)",
            borderRadius: "6px",
            textTransform: "none",
            "&:hover": { borderColor: "var(--color-primary-dark)", backgroundColor: "var(--color-primary-alpha-05)" },
            "&.Mui-disabled": { borderColor: "#ccc", color: "#ccc" },
          }}
          disabled={!(payloadText && selectedParserConfig && isPayloadEdited)}
          onClick={handleParseClick}
        >
          {"Parametrelere Böl"}
        </Button>
      </Grid>
    </Grid>
  );
};

export default PayloadEditor;
